import { Layers } from "appworks/graphics/layers/layers";
import { Services } from "appworks/services/services";
import { stateMachine } from "appworks/state-machine/state-machine";
import { UIFlag, uiFlags, UIMenuFlag } from "appworks/ui/flags/ui-flags";
import { LayerNames } from "game-layers";
import { JurisdictionService } from "slotworks/services/jurisdiction/jurisdiction-service";
import { ButtonControl } from "./button-control";

export class SpinControl extends ButtonControl {
    protected onClick(): void {
        const menusLayer = Layers.get(LayerNames.MenusContent);
        
        if(menusLayer.getSprite('detection_area') != null || menusLayer.getSprite('cover') != null) {
            return;
        }

        stateMachine.skip();
    }

    public override setEnabled(enabled: boolean): void {
        if(!uiFlags.has(UIFlag.EXTERNAL_DISABLE) && uiFlags.has(UIFlag.GAME_IN_PROGRESS) && !uiFlags.has(UIFlag.BIG_WIN_DELAY) && Services.get(JurisdictionService).getSpinSkippingEnabled()) {
            super.setEnabled(true);
        }
        else {
            super.setEnabled(enabled);
        }
    }
}
